export default function ProjectManagement() {
  const phases = [
    {
      number: '01',
      title: 'Étude et Conception',
      description: 'Analyse de vos besoins, étude de faisabilité, conception technique et établissement du budget détaillé.',
      tasks: [
        'Visite du site et relevé des mesures',
        'Analyse des contraintes techniques',
        'Conception des plans et schémas',
        'Devis détaillé par corps de métier',
        'Planning prévisionnel des travaux'
      ]
    },
    {
      number: '02',
      title: 'Préparation du Chantier',
      description: 'Organisation logistique, obtention des autorisations et sélection des artisans partenaires.',
      tasks: [
        'Demandes d\'autorisations administratives',
        'Sélection des corps de métier',
        'Commande des matériaux',
        'Installation du chantier',
        'Réunion de lancement avec tous les intervenants'
      ]
    },
    {
      number: '03',
      title: 'Réalisation des Travaux',
      description: 'Coordination quotidienne des interventions, contrôle qualité et suivi de l\'avancement.',
      tasks: [
        'Coordination des interventions',
        'Contrôle qualité régulier',
        'Gestion des imprévus',
        'Communication avec le client',
        'Ajustements et optimisations'
      ]
    },
    {
      number: '04',
      title: 'Réception et Garanties',
      description: 'Vérification finale, réception des travaux et mise en place des garanties.',
      tasks: [
        'Inspection finale complète',
        'Tests et mises en service',
        'Réception officielle des travaux',
        'Remise de la documentation',
        'Activation des garanties'
      ]
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center mb-16">
          <h2 className="text-base font-semibold leading-7 text-teal-600">Gestion de Projet</h2>
          <p className="mt-2 text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">
            Notre Méthode de Travail
          </p>
          <p className="mt-6 text-lg leading-8 text-gray-600">
            Une approche structurée et professionnelle pour garantir le succès de votre projet de A à Z.
          </p>
        </div>

        <div className="space-y-8">
          {phases.map((phase, index) => (
            <div key={index} className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 shadow-lg border border-gray-100">
              <div className="flex flex-col lg:flex-row gap-8">
                <div className="flex-shrink-0">
                  <div className="w-20 h-20 flex items-center justify-center bg-teal-600 rounded-2xl">
                    <span className="text-3xl font-bold text-white">{phase.number}</span>
                  </div>
                </div>
                <div className="flex-grow">
                  <h3 className="text-2xl font-bold text-gray-900 mb-3">{phase.title}</h3>
                  <p className="text-gray-600 mb-6 leading-relaxed">{phase.description}</p>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                    {phase.tasks.map((task, taskIndex) => (
                      <div key={taskIndex} className="flex items-start">
                        <i className="ri-checkbox-circle-line text-teal-600 text-lg mt-0.5 mr-2"></i>
                        <span className="text-sm text-gray-700">{task}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="bg-teal-50 rounded-2xl p-8 text-center">
            <div className="w-16 h-16 flex items-center justify-center bg-teal-600 rounded-full mx-auto mb-4">
              <i className="ri-time-line text-3xl text-white"></i>
            </div>
            <h4 className="text-xl font-bold text-gray-900 mb-2">Respect des Délais</h4>
            <p className="text-gray-600">Planning rigoureux et coordination optimale pour livrer dans les temps</p>
          </div>
          <div className="bg-orange-50 rounded-2xl p-8 text-center">
            <div className="w-16 h-16 flex items-center justify-center bg-orange-600 rounded-full mx-auto mb-4">
              <i className="ri-money-euro-circle-line text-3xl text-white"></i>
            </div>
            <h4 className="text-xl font-bold text-gray-900 mb-2">Maîtrise du Budget</h4>
            <p className="text-gray-600">Devis détaillé et transparent, sans surprise ni dépassement</p>
          </div>
          <div className="bg-teal-50 rounded-2xl p-8 text-center">
            <div className="w-16 h-16 flex items-center justify-center bg-teal-600 rounded-full mx-auto mb-4">
              <i className="ri-shield-star-line text-3xl text-white"></i>
            </div>
            <h4 className="text-xl font-bold text-gray-900 mb-2">Garantie Globale</h4>
            <p className="text-gray-600">Responsabilité unique et garanties complètes sur tous les travaux</p>
          </div>
        </div>
      </div>
    </section>
  );
}
